import { createListenerMiddleware } from "@reduxjs/toolkit";

import { baseApi } from "@shared/api/baseApi";
import { activatePrivateContext, logIn } from "@shared/api/reduxToolkit";
import { authApi, userApi } from "@shared/api/rtkQuery";

export const authListenerMiddleware = createListenerMiddleware();

authListenerMiddleware.startListening({
  actionCreator: logIn,

  effect: async (_, { dispatch }) => {
    dispatch(baseApi.util.resetApiState());
    try {
      await dispatch(
        userApi.endpoints.getCurrentUser.initiate(undefined, { forceRefetch: true }),
      ).unwrap();
    } catch {
      // getCurrentUser failure is non-fatal — user stays logged in
    }
  },
});

authListenerMiddleware.startListening({
  matcher: authApi.endpoints.logOut.matchFulfilled,
  effect: (_, { dispatch }) => {
    dispatch(activatePrivateContext());
    dispatch(baseApi.util.resetApiState());
  },
});
